<template>
  <div ref="myswiper" class="second-swiper" style="cursor: pointer;min-height: 200px;" id="swiperDiv" v-show="assistantShow">
    <mt-swipe :auto="0" :show-indicators="indicators" @change="handleChange()" v-if="divWidth <= 691">
      <mt-swipe-item v-for="(item,index) in home.assistantList" :key="index">
        <div :id="'moch' + index">
          <div style="width: 100%;height: 100px;">
            <div style="width: 30%;height: 100px;float: left;">
              <img :src="item.tripOne.pgsqlRouteItineraryOne.picture" style="width: 60px;height:60px;border-radius: 5px;margin: 1em auto;">
            </div>
            <div style="width: 70%;height: 100px;text-align:left;float: left;">
              <h5>&nbsp;</h5>
              <h5>{{ item.tripOne.heading }}</h5>
              <h5 style="color: #808080;">{{ item.tripOne.start }}~{{ item.tripOne.end }}</h5>
            </div>
          </div>
          <div class="getMsg" v-for="(mgitem,mgindex) in item.orderAboutUser" :key="mgindex" v-show="mgitem.isShow">
            <div style="width: 80%;height: 70px;text-align: left;float: left;">
              <h3>{{ mgitem.title }}</h3>
              <h5>{{ mgitem.deadline }}</h5>
            </div>
            <div style="width: 20%;height: 70px;float: left;">
              <img src="https://dao-library.54traveler.com/user-center/upload.png" style="width: 40px;margin-top: 50%;" @click="wechatAppletAlert()">
            </div>
            <div style="width: 100%;height: 10px;text-align: left;float: left;">
              <h5>{{ mgitem.note }}</h5>
            </div>
            <div class="borderliss" style="width: 100%;"></div>
          </div>
          <div class="borderliss" style="margin: 1em auto;">
          </div>
          <div style="margin: 0em auto;width: 90%;min-height: 100px;">
            <div @click="gourl(oritem.title,oritem.value)" v-bind:class="{ 'orderOther orderOtherShow' : oritem.value==='','orderOther' : oritem.value!==''}" v-for="(oritem,orindex) in item.orderAboutTrip" :key="orindex">
              <div style="height: 60px;">
                <img v-show="oritem.title === '物资准备'" src="https://dao-library.54traveler.com/user-center/l-wuzi.png" class="mbIcornMenu">
                <img v-show="oritem.title === '关于当地'" src="https://dao-library.54traveler.com/user-center/l-dangdi.png" class="mbIcornMenu">
                <img v-show="oritem.title === '查看合同'" src="https://dao-library.54traveler.com/user-center/l-hetong.png" class="mbIcornMenu">
                <img v-show="oritem.title === '查看保险'" src="https://dao-library.54traveler.com/user-center/l-baodan.png" class="mbIcornMenu">
                <img v-show="oritem.title === '出团通知书'" src="https://dao-library.54traveler.com/user-center/l-chutuan.png" class="mbIcornMenu">
                <img v-show="oritem.title === '群聊二维码'" src="https://dao-library.54traveler.com/user-center/l-wecode.png" class="mbIcornMenu">
                <img v-show="oritem.title === '集合文件'" src="https://dao-library.54traveler.com/user-center/l-fankui.png" class="mbIcornMenu">
              </div>
              <div style="height: 40px;text-align: center;"
                   v-show="oritem.title !== '出团通知书' && oritem.title !== '群聊二维码' && oritem.title !== '集合文件'">
                {{ oritem.title }}
              </div>
              <div class="otherTxt" v-show="oritem.title === '出团通知书' || oritem.title === '群聊二维码' || oritem.title === '集合文件'">
                {{ oritem.title }}<br><span style="font-size: 12px;color: silver;">{{ oritem.subtitle }}</span>
              </div>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </mt-swipe-item>
    </mt-swipe>
    <div v-if="divWidth > 691">
      <div v-for="(item,index) in home.assistantList" :key="index" v-show="swiperPage===index">
        <div :id="'mochb' + index">
          <div style="width: 100%;height: 100px;">
            <div style="width: 30%;height: 100px;float: left;">
              <img :src="item.tripOne.pgsqlRouteItineraryOne.picture" style="width: 60px;height:60px;border-radius: 5px;margin: 1em auto;">
            </div>
            <div style="width: 50%;height: 100px;text-align:left;float: left;">
              <h5>&nbsp;</h5>
              <h5>{{ item.tripOne.heading }}</h5>
              <h5 style="color: #808080;">{{ item.tripOne.start }}~{{ item.tripOne.end }}</h5>
            </div>
            <div style="width: 20%;height: 100px;text-align:right;float: left;">
              <span style="color: #E60012;font-size:14px;line-height:100px;margin-right: 5%;">更多>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
          </div>
          <div class="getMsg" v-for="(mgitem,mgindex) in item.orderAboutUser" :key="mgindex" v-show="mgitem.isShow">
            <div style="width: 80%;height: 70px;text-align: left;float: left;">
              <h3>{{ mgitem.title }}</h3>
              <h5>{{ mgitem.deadline }}</h5>
            </div>
            <div style="width: 20%;height: 70px;float: left;">
              <img src="https://dao-library.54traveler.com/user-center/upload.png" style="width: 40px;margin-top: 50%;">
            </div>
            <div style="width: 100%;height: 10px;text-align: left;float: left;">
              <h5>{{ mgitem.note }}</h5>
            </div>
            <div class="borderliss" style="width: 100%;"></div>
          </div>
          <div class="borderliss" style="margin: 1em auto;">
          </div>
          <div style="margin: 0em auto;width: 90%;height: 100px;">
            <div @click="goStrokeUrl(oritem.title,oritem.value)" v-bind:class="{ 'orderOther orderOtherShow' : oritem.value==='','orderOther' : oritem.value!==''}" v-for="(oritem,orindex) in item.orderAboutTrip" :key="orindex">
              <div style="height: 60px;">
                <img v-show="oritem.title === '物资准备'" src="https://dao-library.54traveler.com/user-center/l-wuzi.png" class="pcIcornMenu">
                <img v-show="oritem.title === '关于当地'" src="https://dao-library.54traveler.com/user-center/l-dangdi.png" class="pcIcornMenu">
                <img v-show="oritem.title === '查看合同'" src="https://dao-library.54traveler.com/user-center/l-hetong.png" class="pcIcornMenu">
                <img v-show="oritem.title === '查看保险'" src="https://dao-library.54traveler.com/user-center/l-baodan.png" class="pcIcornMenu">
                <img v-show="oritem.title === '出团通知书'" src="https://dao-library.54traveler.com/user-center/l-chutuan.png" class="pcIcornMenu">
                <img v-show="oritem.title === '群聊二维码'" src="https://dao-library.54traveler.com/user-center/l-wecode.png" class="pcIcornMenu">
                <img v-show="oritem.title === '集合文件'" src="https://dao-library.54traveler.com/user-center/l-fankui.png" class="pcIcornMenu">
              </div>
              <div style="height: 40px;text-align: center;" v-show="oritem.title !== '出团通知书' && oritem.title !== '群聊二维码' && oritem.title !== '集合文件'">
                {{ oritem.title }}
              </div>
              <div class="otherTxt"
                   v-show="oritem.title === '出团通知书' || oritem.title === '群聊二维码' || oritem.title === '集合文件'">
                {{ oritem.title }}<br><span style="font-size: 12px;color: silver;">{{ oritem.subtitle }}</span>
              </div>
            </div>
          </div>
          <div style="width: 100%;height: 40px;line-height: 40px;">
            <div style="width: 50%;margin-left: 40%;margin-top: 3em;">
              <div v-for="(dditem,ddindex) in home.assistantList" :key="ddindex"
                   v-bind:class="{ 'pageDianSelect' : swiperPage===ddindex,'pageDian' : swiperPage!==ddindex}"
                   @click="changePage(ddindex)">
              </div>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchAccountAssistantList } from '@/api/user/account'
export default {
  name: 'd-swiper',
  props: {
    list: Array,
    catalog: String
  },
  data () {
    return {
      swiperHeight: 600,
      swiperPage: 0,
      divWidth: 0,
      assistantShow: true,
      indicators: true,
      home: [],
      assembileUrl: process.env.ASSEMBILE_URL
    }
  },
  mounted () {
    this.homeInfo()
  },
  created () {
    // this.homeInfo()
  },
  methods: {
    // H5 小程序弹窗提醒
    wechatAppletAlert () {
      // MessageBox.alert('请前往小程序进行上传处理', '⚠️ 提示')
    },
    // 切换目录
    changePage (index) {
      this.swiperPage = index
    },
    // 行程助手
    homeInfo () {
      fetchAccountAssistantList().then(response => {
        this.home = response.data
        if (response.data.assistantList.length < 1) {
          this.assistantShow = false
          this.divWidth = 0
        } else {
          setTimeout(() => {
            this.handleChange()
          }, 500)
        }
      })
    },
    // 高度计算
    calHeight () {
      this.$nextTick(() => {
        let h = document.getElementById('moch0').clientHeight
        this.swiperHeight = h + 50
        this.$refs.myswiper.style.height = this.swiperHeight + 'px'
      })
    },
    // 切换
    handleChange () {
      let w = document.getElementById('swiperDiv').clientWidth
      this.divWidth = w
      if (this.divWidth > 691) {
        this.indicators = false
      } else {
        this.$refs.myswiper.style.height = this.swiperHeight + 'px'
      }
      let h = this.swiperHeight
      this.home.assistantList.forEach((item, index) => {
        if (document.getElementById('moch' + index).clientHeight > 0) {
          h = document.getElementById('moch' + index).clientHeight
        }
      })
      if (this.divWidth <= 691) {
        this.swiperHeight = h + 50
        this.$refs.myswiper.style.height = this.swiperHeight + 'px'
      }
    },
    // 跳转自定义链接
    gourl (type, url) {
      if (type === '查看保险') {
        alert(url)
      } else {
        if (url !== '') {
          window.location.href = url
        }
      }
    },
    // 行程助手功能列表跳转
    goStrokeUrl (type, url) {
      if (type === '查看保险') {
        // MessageBox.alert(url, '⚠️ 提示')
      } else {
        if (type === '物资准备' || type === '关于当地') {
          // MessageBox.alert('请使用小程序登录查看', '⚠️ 提示')
        } else {
          if (url !== '') {
            window.location.href = url
          }
        }
      }
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
.pcIcornMenu {
  width: 40px;
  margin-top: 5%;
}

.mbIcornMenu {
  width: 40px;
  margin-top: 15%;
}

.pageDianSelect {
  width: 20px;
  height: 20px;
  border-radius: 15px;
  float: left;
  margin-left: 10px;
  background-color: #E60012;
}

.pageDian {
  width: 20px;
  height: 20px;
  border-radius: 15px;
  float: left;
  margin-left: 10px;
  background-color: #808080;
}

.getMsg {
  margin: 0em auto;
  width: 90%;
  height: 100px;
  margin-top: 5px;
}

.otherTxt {
  height: 40px;
  text-align: center;
}

.otherIcon {
  width: 40px;
  margin-top: 15%;
}

.orderOtherShow {
  opacity: 0.4;
}

.orderOther {
  width: 25%;
  height: 100px;
  float: left;
}

@media (max-width: 768px) {
  .orderOther {
    width: 33.3%;
    height: 100px;
    float: left;
  }
}

.orderOtherThree {
  width: 33.3%;
  height: 100px;
  float: left;
}

.borderliss {
  margin: 0em auto;
  border-bottom: 1px solid #dddddd;
  width: 90%;
  height: 5px;
}

.second-swiper {
  /*background-color: #e2e2e2;*/
  margin-bottom: 10px;
  min-height: 120px;
  background-color: #ffffff;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/swiper.vue